<template>
  <div class="compressed-content">
    <h3>
      On a scale of 1 (low/not confident) to 10 (high/confident), how would you rate: <br />
      I feel that my overall physical health is in a good state(e.g., energy levels, absence of illness)
    </h3>
    <v-form-group class="card-selector page-buttons" label="Scale">
      <v-select :class="[{ 'vs--has-value': selectedValue !== null }]"
                v-model="selectedValue"
                :options="options"
                placeholder="Scale"
                @input="onInput" />
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    data() {
      return {
        selectedValue: null
      }
    },

    created() {
      if (this.survey.lifestyleFactors.physicalRating) {
        this.selectedValue = this.options.find(option => option.value === this.survey.lifestyleFactors.physicalRating);
      }
    },

    computed: {
      ...mapState(["survey"]),

      options() {
        let options = [];
        [...Array(10).keys()].map(i => { return { value: i + 1, label: String(i + 1) } }).forEach(i => options.push(i));
        return options;
      },
    },

    methods: {
      onInput() {
        this.survey.lifestyleFactors.physicalRating = this.selectedValue.value;
      }
    }
  };
</script>